// extracted by mini-css-extract-plugin
module.exports =  {"root":"gKgxxbToLwmuMLnw800F"};